import {Pipe, PipeTransform} from '@angular/core';
import {TranslateService} from '@ngx-translate/core';


function isTime(value: string | number) {
  return /^[0-9]{1,2}\:[0-9]{1,2}$/.test(value.toString());
}

function addLeadZero(num, isNegative = false) {
  return (isNegative ? '-' : '') + ('000' + Math.abs(num)).slice(-2);
}

export function parseIntervalToMinutes(interval: string) {
  if (!isTime(interval)) {
    return 0;
  }

  const parts = interval.split(':');
  const hours = parseInt(parts[0], 10);
  const minutes = parseInt(parts[1], 10);
  if (isNaN(hours) || isNaN(minutes)) {
    throw new Error(interval + ' не может быть обработан как время HH:MM');
  }
  return 60 * hours + minutes;
}

export function shortWeekdayToNum(dayKey: string) {
  switch (dayKey) {
    case 'sun':
      return 0;
    case 'mon':
      return 1;
    case 'tue':
      return 2;
    case 'wed':
      return 3;
    case 'thu':
      return 4;
    case 'fri':
      return 5;
    case 'sat':
      return 6;
    case 'd1':
      return 7;
    case 'd2':
      return 8;
  }
  return -1;
}

export function formatNumberToTime(num) {
  if (isTime(num)) {
    return num;
  }
  const value = parseInt(num, 10);
  const isNegative = value < 0 ? true : false;
  const absValue = Math.abs(value);
  return addLeadZero(Math.floor(absValue / 60), isNegative) + ':' + addLeadZero(absValue % 60);
}

export function numToShortWeekday(num) {
  const days = [
    'sun',
    'mon',
    'tue',
    'wed',
    'thu',
    'fri',
    'sat',
    'd1',
    'd2'
  ];
  return days[parseInt(num, 10)] ? days[parseInt(num, 10)] : 'custom';
}

export function shortToFullWeekday(day) {
  const days = {
    sun: 'sunday',
    mon: 'monday',
    tue: 'tuesday',
    wed: 'wednesday',
    thu: 'thursday',
    fri: 'friday',
    sat: 'saturday',
    d1: 'day1',
    d2: 'day2'
  };
  return days[day];
}


@Pipe({
  name: 'shortToFullWeekday'
})
export class ShortToFullWeekdayPipe implements PipeTransform {
  transform(value: any, args?: any): any {
    return shortToFullWeekday(value);
  }
}

/**
 * Pipe используется для преобразования числа в день недели
 * 0-6 - вс-сб, 7,8 - день1, день2
 */
@Pipe({
  name: 'numToShortWeekday'
})
export class NumToShortWeekdayPipe implements PipeTransform {

  transform(value: any, args?: any): any {
    return numToShortWeekday(value);
  }

}

@Pipe({
  name: 'formatNumToTime'
})
export class FormatNumToTime implements PipeTransform {
  transform(value: any, args?: any): any {
    if (args) {
      let isHour = false;
      let isMin = false;
      let isSec = false;
      if ((args as string).indexOf('HH') !== -1) {
          isHour = true;
      }
      if ((args as string).indexOf('mm') !== -1) {
        isMin = true;
      }
      if ((args as string).indexOf('SS') !== -1) {
        isSec = true;
      }
      const absValue = Math.floor(Math.abs(value / 1000));
      let hours = 0;
      let hh = '00';
      if (isHour) {
        hours = Math.floor(absValue / (60 * 60));
        hh =  String(hours < 10 ? '0' + hours : hours);
      }
      let Mins = 0;
      let MM = '00';
      if (isMin) {
        Mins = Math.ceil((absValue - hours * 60 * 60) / 60);
        MM =  String(Mins < 10 ? '0' + Mins : Mins);
      }
      let sec = 0;
      let ss = '00';
      if (isSec) {
        sec = absValue - hours * 60 * 60 - Mins * 60;
        ss = String(sec < 10 ? '0' + sec : sec);
      }
      if (isHour && isMin && isSec) {
        return hh + ':' + MM + ':' + ss;
      } else if (isHour && isMin) {
        return hh + ':' + MM;
      } else if (isMin && isSec) {
        return MM + ':' + ss;
      } else if (isHour) {
        return hh;
      } else if (isMin) {
        return MM;
      } else if (isSec) {
        return ss;
      }
    }
    return formatNumberToTime(value);
  }
}

@Pipe({
  name: 'inDate'
})
export class InDate implements PipeTransform {
  constructor(private translate: TranslateService) {
  }

  transform(value: any, args?: string): any {
    const isSec =  args ? args.indexOf('ss') !== -1 : false;
    const isHour = args ? args.indexOf('hh') !== -1 : true;
    const isMin =  args ? args.indexOf('MM') !== -1 : true;
    const date = new Date(value);
    const now = new Date();
    const time = (isHour ? `${('0' + date.getHours()).slice(-2)}` : ``)
                  + (isMin ? `:${('0' + date.getMinutes()).slice(-2)}` : ``)
                  + (isSec ? `:${('0' + date.getSeconds()).slice(-2)} ` : ``);
    if (date.getFullYear() === now.getFullYear() && date.getMonth() === now.getMonth() && date.getDate() === now.getDate()) {
      return this.translate.instant('today at') + ' ' + time;
    } else {
      return ('0' + date.getDate()).slice(-2) + '.' + ('0' + (date.getMonth() + 1)).slice(-2) + '.' + ('0' + date.getFullYear()).slice(-2) + ' ' + time;
    }
  }
}
